<template>
  <div>
    <div class="mb-inquiry">
      <!-- ヘッダー -->
      <MFITTHeader headerTitle="特急ロマンスカー予約・購入" :clickBackButtonEvent="backToPage" />

      <section class="form">
        <!-- 乗車日選択&時間選択&往路選択 出発/到着 -->
        <MFITTBookingSelectDate v-model:dateRadio="dateRadio" v-model:selectedDate="selectedDate"
          v-model:selectedTime="selectedTime" :isValidDate="isValidDate" />

        <!-- 区間選択 -->
        <MFITTBookingSelectStationSection :fromStationOptions="fromStationOptions" :toStationOptions="toStationOptions"
          :switchStations="switchStations" :isInvalidStations="isInvalidStations" v-model:fromStation="fromStation"
          v-model:toStation="toStation" />

        <!-- 利用人数選択(引換券使用時は固定) -->
        <MFITTBookingDivisionAdult v-if="isUseCoupon" />
        <MFITTBookingSelectDivision v-else v-model:adult="adult" v-model:child="child" />

        <!-- 発着照会追加 ラジオボタン -->
        <!-- サブスク引換券使用時のみ非表示 -->
        <MFITTBookingAddInquiry v-if="!isSubscription"
          :stations="addInquiryRadio == 1 ? fromStationOptions : toStationOptions"
          v-model:addInquiryRadio="addInquiryRadio" v-model:addInquiryStation="addInquiryStation"
          :isValidAddInquiryStation="isValidAddInquiryStation" />

        <!-- チケット規約  -->
        <MFITTTermsButtons />
      </section>
    </div>

    <!-- 利用規約のチェックと、次ページへのアクションボタン -->
    <!-- 発着照会追加のラジオの値に応じて、secondXXStationを渡す(1:発駅、2:着駅) -->
    <MFITTBookingBottomButton :boardingDate="selectedDate" :searchDivision="dateRadio" :time="selectedTime"
      :fromStation="fromStation" :toStation="toStation"
      :secondFromStation="addInquiryRadio == 1 ? addInquiryStation : null"
      :secondToStation="addInquiryRadio == 2 ? addInquiryStation : null" :adultCount="adult" :childCount="child"
      :isCompleteInput="isCompleteInput" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";
import moment from "@/services/moment";

export default {
  name: "TemplateMfittBooking1",
  props: {
    stations: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);
    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isUseCoupon = selectedCoupon != null;
    const isSubscription = isUseCoupon && selectedCoupon.type == "subscription";

    // 日付選択 出発:3, 到着:4
    // 出発をデフォ設定
    const dateRadio = ref(3);
    // 当日をデフォ設定
    const selectedDate = ref(moment(new Date()).format("YYYY-MM-DD"));

    // 現在時刻をデフォ設定
    const selectedTime = ref(moment(new Date()).format("HH:mm"));

    // 有効な日付が選択されているか？
    // local(Chrome), AndroidだとカレンダーUIで選択日付をブロックできるが、iOSはできないのでこのチェックが必要
    const isValidDate = computed(() => {
      if (isUseCoupon) {
        return mfittService.hasSelectedValidDateWithCoupon(
          selectedCoupon,
          selectedDate.value
        );
      } else {
        return mfittService.checkIsFromTodayUntilOneMonth(selectedDate.value);
      }
    });

    // 区間選択
    const fromStation = ref({});
    const toStation = ref({});

    // 区間の選択肢
    const fromStationOptions = ref(props.stations);
    const toStationOptions = ref(props.stations);

    // 発着駅が同一の場合trueで無効扱い
    const isInvalidStations = ref(false);

    // 区間が選択されているか？
    const isSelectedStations = computed(
      () =>
        Object.keys(fromStation.value).length > 0 &&
        Object.keys(toStation.value).length > 0
    );

    // 発着照会追加の駅は有効か？(区間の発/着駅と被っている場合は無効)
    const isValidAddInquiryStation = computed(() => {
      // 発着照会追加なしの場合、検証不要
      if (addInquiryRadio.value === 0) {
        return true;
        // 発駅の追加がある場合
      } else if (addInquiryRadio.value === 1) {
        return (
          addInquiryStation.value.id &&
          addInquiryStation.value.id !== fromStation.value.id
        );
        // 着駅の追加がある場合
      } else if (addInquiryRadio.value === 2) {
        return (
          addInquiryStation.value.id &&
          addInquiryStation.value.id !== toStation.value.id
        );
      } else {
        return true;
      }
    });

    // 人数選択
    const adult = ref(1);
    const child = ref(0);
    // 人数が1人以上選択されているか？
    const isSelectedDivisions = computed(() => adult.value + child.value > 0);

    // 発着照会追加
    const addInquiryRadio = ref(0);
    const addInquiryStation = ref({});

    // 必要な情報が全て入力されているか？
    const isCompleteInput = computed(
      () =>
        isValidDate.value &&
        selectedTime.value != "" &&
        isSelectedStations.value &&
        !isInvalidStations.value &&
        isSelectedDivisions.value &&
        isValidAddInquiryStation.value
    );

    // 区間選択の発着入れ替え
    const switchStations = () => {
      const tmpDepartureStation = fromStation.value;
      const tmpArrivalStation = toStation.value;

      fromStation.value = tmpArrivalStation;
      toStation.value = tmpDepartureStation;
    };

    // headerのbackButton用の処理。
    const backToPage = () => {
      if (myCoupons.value && myCoupons.value.length > 0) {
        router.push({
          name: "MfittSelectCoupon",
        });
      } else {
        nativeHandlerService.returnNativeAppMfittIndexPage();
      }
    };

    const filterStationOptions = (options, allowedStations) => {
      return options.filter((station) => allowedStations.some((allowedStation) => station.id == allowedStation.id));
    };

    const filterStationOptionsIfCouponHasAllowedStations = () => {
      if (selectedCoupon && selectedCoupon.allowed_from_stations) {
        fromStationOptions.value = filterStationOptions(fromStationOptions.value, selectedCoupon.allowed_from_stations);

        // 特付FPで箱根湯本がある場合はデフォルトで表示。
        if (selectedCoupon.type === "exchange" && fromStationOptions.value.some(option => option.name == "箱根湯本")) {
          fromStation.value = fromStationOptions.value.find(option => option.name == "箱根湯本")
        }
        // 初期セットした駅が選択肢に存在しない場合は、選択肢の先頭の駅をセット
        if (!fromStationOptions.value.some(option => option.id == fromStation.value.id)) {
          fromStation.value = fromStationOptions.value[0];
        }
      }

      if (selectedCoupon && selectedCoupon.allowed_to_stations) {
        toStationOptions.value = filterStationOptions(toStationOptions.value, selectedCoupon.allowed_to_stations);

        // 特付FPで箱根湯本がある場合はデフォルトで表示。
        if (selectedCoupon.type === "exchange" && toStationOptions.value.some(option => option.name == "箱根湯本")) {
          toStation.value = toStationOptions.value.find(option => option.name == "箱根湯本")
        }
        // 初期セットした駅が選択肢に存在しない場合は、選択肢の先頭の駅をセット
        if (!toStationOptions.value.some(option => option.id == toStation.value.id)) {
          toStation.value = toStationOptions.value[0];
        }
      }
    }


    const setLocalOrDefaultFromStation = () => {
      // 前回選択した区間がない場合は新宿をデフォルト設定
      const localFromStationId = localStorage.getItem("fromStationId");
      if (localFromStationId != null) {
        const target = props.stations.find(
          (station) => station.id == localFromStationId
        );
        if (target) {
          fromStation.value = target;
        } else {
          fromStation.value = props.stations.find(
            (station) => station.name == "新宿"
          );
        }
      } else {
        fromStation.value = props.stations.find(
          (station) => station.name == "新宿"
        );
      }
    };

    const setLocalOrDefaultToStation = () => {
      // 前回選択した区間がない場合は箱根湯本をデフォルト設定
      const localToStationId = localStorage.getItem("toStationId");
      if (localToStationId != null) {
        const target = props.stations.find(
          (station) => station.id == localToStationId
        );
        if (target) {
          toStation.value = target;
        } else {
          toStation.value = props.stations.find(
            (station) => station.name == "箱根湯本"
          );
        }
      } else {
        toStation.value = props.stations.find(
          (station) => station.name == "箱根湯本"
        );
      }
    };

    // 描画時、storeから情報を反映
    const setInputByStore = (storeValues) => {
      selectedDate.value = storeValues.boarding_date;
      selectedTime.value = storeValues.time;
      dateRadio.value = storeValues.search_division;

      adult.value = storeValues.adult_count;
      child.value = storeValues.child_count;

      fromStation.value = storeValues.from_station;
      toStation.value = storeValues.to_station;

      if (storeValues.second_from_station) {
        addInquiryStation.value = storeValues.second_from_station;
        addInquiryRadio.value = 1;
      } else if (storeValues.second_to_station) {
        addInquiryStation.value = storeValues.second_to_station;
        addInquiryRadio.value = 2;
      }
    };

    // 描画時、queryから情報を反映(経路検索からの遷移やURLスキームで開かれた場合)
    const setInputByQuery = () => {
      // 日時
      selectedDate.value = mfittService.convertQueryDate(
        route.query.boarding_date
      );
      selectedTime.value = mfittService.convertQueryTime(route.query.time);
      dateRadio.value = mfittService.convertQuerySearchDivision(
        route.query.start_location
      );

      // 人数
      adult.value =
        route.query.adults_num != undefined
          ? Number(route.query.adults_num)
          : 1;
      child.value =
        route.query.children_num != undefined
          ? Number(route.query.children_num)
          : 0;

      // 出発駅
      if (
        route.query.from_station_id != undefined &&
        route.query.from_station_id != null
      ) {
        fromStation.value = mfittService.getStationFromQuery(
          route.query.from_station_id,
          route.query.id_type,
          props.stations
        );
      } else {
        setLocalOrDefaultFromStation();
      }

      // 到着駅
      if (
        route.query.to_station_id != undefined &&
        route.query.to_station_id != null
      ) {
        toStation.value = mfittService.getStationFromQuery(
          route.query.to_station_id,
          route.query.id_type,
          props.stations
        );
      } else {
        setLocalOrDefaultToStation();
      }
    };

    // 描画時、ローカルストレージから区間を反映
    const setInputByLocalStorage = () => {
      setLocalOrDefaultFromStation();
      setLocalOrDefaultToStation();
    };

    const setInitInput = () => {
      const inputtedInfoOnBooking =
        store.getters["MFITT/inputtedInfoOnBooking"];
      // 前の画面から戻った場合など、storeに入力情報がある場合はそれを反映
      if (inputtedInfoOnBooking != null) {
        setInputByStore(inputtedInfoOnBooking);
      } else if (route.query.id_type) {
        // 経路検索やURLスキームで遷移してきた場合、queryの情報を反映(id_typeは必須項目なので、その有無で判別する)
        setInputByQuery();
      } else {
        // localStorageから前回選択した区間を取得
        setInputByLocalStorage();
      }
    };

    onMounted(() => {
      setInitInput();
      filterStationOptionsIfCouponHasAllowedStations();
    });

    watchEffect(() => {
      // 発着照会追加で「無し」を選択したら、選択中の駅をリセットする
      if (addInquiryRadio.value == 0) {
        addInquiryStation.value = {};
      }
      // 発着駅に同一駅を選択した場合
      if (fromStation.value.id == toStation.value.id) {
        isInvalidStations.value = true;
      }
      if (
        isInvalidStations.value &&
        fromStation.value.id != toStation.value.id
      ) {
        isInvalidStations.value = false;
      }
    });

    return {
      props,
      isUseCoupon,
      isSubscription,
      dateRadio,
      selectedDate,
      selectedTime,
      isValidDate,
      fromStation,
      toStation,
      fromStationOptions,
      toStationOptions,
      isInvalidStations,
      switchStations,
      adult,
      child,
      isCompleteInput,
      addInquiryRadio,
      addInquiryStation,
      isValidAddInquiryStation,
      backToPage,
    };
  },
};
</script>

<style socped>
.mb-inquiry {
  margin-bottom: 160px;
}

.form {
  margin: 20px 15px;
}
</style>
